import ReactDOM from 'react-dom/client'
import { BrowserRouter } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'react-calendar/dist/Calendar.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './assets/style/style.min.css'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
)